












































































































import CreateAffirmationViewModel from "@models/affirmations/createAffirmationViewModel";
import {
  COVER_IMAGE_RATIO,
  BACKGROUND_IMAGE_RATIO,
  ICON_IMAGE_RATIO,
} from "@/appSettings";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import AnimationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse";

@Component
export default class CreateAffirmationComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  currentAudioGroup: AudioGroupViewModel = null;
  isEditAudio = false;
  iconImageRatio = ICON_IMAGE_RATIO;
  coverImageRatio = COVER_IMAGE_RATIO;
  backgroundImageRatio = BACKGROUND_IMAGE_RATIO;
  get title(): string {
    return this.id ? "Редактирование аффирмации" : "Добавление аффирмации";
  }
  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  vm: CreateAffirmationViewModel = new CreateAffirmationViewModel();
  onAnimationChanged(item: AnimationResponse) {
    if (item != null) {
      this.vm.animationUrl = item.Url;
    }
  }
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.vm.initLanguages(this.languages);
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }
  async fetchData() {
    this.isLoading = true;
    const res = await this.$api.AffirmationService.getDetailAsync(this.id);
    this.vm.fromServerModel(res);
    this.isLoading = false;
  }
  async save() {
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.vm.toServerModel();
    const res = await this.$api.AffirmationService.updateAsync(request);
    if (res) {
      this.$dialog.success("Аффирмация успешно обновлена");
      this.$router.back();
    }
    this.isLoading = false;
  }
  audioGroupChanged(audioGroup: AudioGroupViewModel) {
    if (audioGroup == null) {
      this.currentAudioGroup = null;
      this.isEditAudio = false;
      return;
    }
    if (this.audioAddMode == "edit") {
      Object.assign(this.currentAudioGroup, audioGroup);
    } else if (this.audioAddMode == "add") {
      this.vm.audios.push(audioGroup);
    }
    this.currentAudioGroup == null;
    this.isEditAudio = false;
  }
  audioAddMode: "edit" | "add" | null = null;
  startAddAudio() {
    this.currentAudioGroup = new AudioGroupViewModel(this.languages);
    this.audioAddMode = "add";
  }
  startEditAudioGroup(item: AudioGroupViewModel) {
    this.currentAudioGroup = item;
    this.audioAddMode = "edit";
    this.isEditAudio = true;
  }
  deleteAudioGroup(item: AudioGroupViewModel) {
    this.vm.audios = this.vm.audios.filter((x) => x != item);
  }
}
